import React from "react";
import styled from "styled-components";

export default function Textarea({ label, placeholder, id }) {
  return (
    <StyledTextarea>
      <label htmlFor={id}>{label}</label>
      <textarea id={id} placeholder={placeholder}></textarea>
    </StyledTextarea>
  );
}

const StyledTextarea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  label {
    color: var(--text-2);
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 135.714% */
    padding-left: 20px;
  }

  textarea {
    padding: 18px 20px;
    outline: none;
    border-radius: 30px;
    border: 1px solid var(--border);
    background-color: var(--white);
    resize: vertical;
    min-height: 120px;
    color: var(--text-2);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 147.059% */
    transition: border 0.4s ease;

    &::placeholder {
      color: var(--secondary);
    }

    &:hover,
    &:focus {
      border-color: var(--light-blue);
    }
  }
`;
